import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FieldType } from '@ngx-formly/core';
import { Subject } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'formly-table',
  template: `
    <app-table-filter *ngIf="props.filters"
      [parentComponent]="props.parentComponent"
      [fields]="props.filterFields"
      (filterChanged)="onFilterChanged($event)"
      (filterInit)="onFilterChanged($event,true)">
    </app-table-filter>

    <app-table-view
      [config]="props.config"
      [data]="data"
      [relative]="true"
      [selections]="selection"
      [isEditable]="props.isEditable"
      [tableContainerMinWidth]="props.tableContainerMinWidth"
      [footerTemplate]="props.footerTemplate"
      [disableOneRowSelection]="props.disableOneRowSelection"
      (checkboxSelected)="onRowSelected($event)"
      (paginationChanged)="onPaginationChanged($event)"
      [disableOneRowSelection]="true"
    >
    </app-table-view>
  `,
})
export class FormlyTableComponent extends FieldType implements OnInit {

  private currentSelection: any[] = [];
  selection = [];

  get data() {
    const control = this.form.get(this.controlId);
    if (control && control.value && control.value !== null) {
      return this.props.config.paginator ? control.value : [...control.value];
    }
    return this.props.config.paginator ? {content: []} : [];
  }

  set data(val: any) {
    this.onTableUpdate(val);
    if (this.form.get(this.controlId)) {
      this.form.get(this.controlId).setValue(val);
    }
  }

  private get controlId(): string {
    return this.props.controlId;
  }

  private entryId = 0;

  constructor(private cd: ChangeDetectorRef) {
    super();
  }

  ngOnInit(): void {
    this.initApplyInitialDataSub();
    this.initUpdateDataSub();
    this.initRefreshSelectedSub();
    this.disableTableIfApplicable();
    if (this.props.selections) {
      this.selection = [...this.props.selections];
    }
  }

  public onRowSelected(data: any, background = false): void {
    const { onRowSelected } = this.props;

    if (typeof onRowSelected === 'function') {
      this.currentSelection = data;
      onRowSelected(data, background);
    }
  }

  public onPaginationChanged($event): void {
    const { onPaginationChanged } = this.props;

    if (typeof onPaginationChanged === 'function') {
      onPaginationChanged($event);
    }
  }

  public onFilterChanged(event, init) {
    const { onFilterChanged } = this.props;
    if (!init && typeof onFilterChanged === 'function') {
      this.props.onFilterChanged(event);
    }
  }

  private disableTableIfApplicable(): void {
    if (this.props.disabled) {
      this.props.config.selectDisabled = true;
    }
  }

  private initApplyInitialDataSub(): void {
    const { initialData } = this.props;
    const source = initialData instanceof Array ? initialData : [];
    this.applyData(source);
  }

  private initRefreshSelectedSub(): void {
    const requestSelected: Subject<any[]> = this.props.requestSelected;

    if (!requestSelected) {
      return;
    }

    requestSelected.pipe(untilDestroyed(this)).subscribe(value => {
      this.currentSelection = value;
      this.selection = [...value];
      this.onRowSelected(this.currentSelection, true);
    });
  }

  private initUpdateDataSub(): void {
    const updateData: Subject<any[]> = this.props.updateData;

    if (!updateData) {
      return;
    }

    updateData.pipe(untilDestroyed(this)).subscribe(value => {
      this.applyData(value);
    });
  }

  private applyData(data: any[]): void {
    if (this.props.config.paginator) {
      this.data = data;
    } else {
      this.data = data.map(entry => {
        this.entryId++;
        return {
          ...entry,
          id: entry.id ? entry.id : this.entryId,
        };
      });
    }
    this.cd.detectChanges();
  }

  private onTableUpdate(value: any): void {
    const { onTableUpdate } = this.props;

    if (typeof onTableUpdate === 'function') {
      onTableUpdate(value);
    }
  } 
}
